module.exports = __webpack_public_path__ + "static/media/agua.e49695d6.mp4";